import { tmsApi } from '@/api/index'

/**
 * 接口通用方法
 * @param data
 */
export function interfaceMethod (data: any) {
  const url = '/' + ['interfaceMethod', data.m.toLowerCase(), data.n.toLowerCase()].join('/')
  return tmsApi.request({
    method: 'post',
    url,
    data
  })
}
